import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
  standalone: true,
  imports: [
    TranslateModule,
  ]
})
export class DeleteDialogComponent implements OnInit {
  @Input() idsText: string = 'IDS_DELETE_CONFIRM';
  @Input() idsDeleteButton: string = 'IDS_BTN_DELETE';

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
